module.exports = __webpack_public_path__ + "img/ico_2_phone_b.66098364.svg";